(() => {
  'use strict';
  if (window.galerieCoffretsCarouselLoaded) return;
  window.galerieCoffretsCarouselLoaded = true;
  const instances = new WeakMap();
  const setup = root => {
    if (instances.has(root)) return;
    const track = root.querySelector('[data-coffrets-track]');
    const prev = root.querySelector('[data-coffrets-prev]');
    const next = root.querySelector('[data-coffrets-next]');
    if (!track || !prev || !next) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const state = () => {
      const max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    };
    const step = () => (track.querySelector('.coffrets-card')?.getBoundingClientRect().width || track.clientWidth) + (parseFloat(getComputedStyle(track).columnGap) || 0);
    const move = direction => track.scrollBy({left: direction * step(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    prev.addEventListener('click', () => move(-1), options);
    next.addEventListener('click', () => move(1), options);
    track.addEventListener('scroll', state, {...options, passive:true});
    track.addEventListener('keydown', event => {
      if (event.target !== track) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1); }
      if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); track.scrollTo({left:event.key === 'Home' ? 0 : track.scrollWidth, behavior:'instant'}); }
    }, options);
    let pointer = null, dragged = false, clickTimer;
    track.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      pointer = {id:event.pointerId, x:event.clientX, scroll:track.scrollLeft};
      dragged = false;
    }, options);
    track.addEventListener('pointermove', event => {
      if (!pointer || event.pointerId !== pointer.id) return;
      const delta = event.clientX - pointer.x;
      if (!dragged && Math.abs(delta) < 6) return;
      if (!dragged) { dragged = true; track.setPointerCapture(event.pointerId); track.classList.add('is-dragging'); }
      track.scrollLeft = pointer.scroll - delta;
    }, options);
    const endDrag = () => {
      if (pointer && track.hasPointerCapture(pointer.id)) track.releasePointerCapture(pointer.id);
      pointer = null;
      track.classList.remove('is-dragging');
      clearTimeout(clickTimer);
      clickTimer = setTimeout(() => { dragged = false; }, 0);
    };
    track.addEventListener('pointerup', endDrag, options);
    track.addEventListener('pointercancel', endDrag, options);
    track.addEventListener('pointerleave', () => { if (!dragged) pointer = null; }, options);
    track.addEventListener('dragstart', event => event.preventDefault(), options);
    track.addEventListener('click', event => { if (dragged) { event.preventDefault(); event.stopPropagation(); } }, {...options, capture:true});
    const observer = new ResizeObserver(state);
    observer.observe(track);
    state();
    instances.set(root, () => { controller.abort(); observer.disconnect(); clearTimeout(clickTimer); });
  };
  const initialise = scope => {
    if (scope.matches?.('[data-coffrets-carousel]')) setup(scope);
    scope.querySelectorAll('[data-coffrets-carousel]').forEach(setup);
  };
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-coffrets-carousel]').forEach(root => instances.get(root)?.()));
  document.addEventListener('shopify:block:select', event => {
    const card = event.target.closest('.coffrets-card');
    const track = card?.closest('[data-coffrets-track]');
    if (track) track.scrollTo({left:card.offsetLeft-track.offsetLeft,behavior:'instant'});
  });
})();
